export enum ErrorStatus {
  Raised = 'RAISED',
  Handled = 'HANDLED',
  Unhandled = 'UNHANDLED',
}
